module.exports = __webpack_public_path__ + "img/sage-collective_thumbnail.1e5340f5.jpg";